import { Box, Typography } from '@mui/material';

const PlateRibbon = ({ ribbon = {}, text }) => {
  const { color_back = '#e67e22', color_text = '#fff' } = ribbon;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 190,
        height: 25,
        bgcolor: color_back || '#e67e22',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'rotate(45deg) translate(25%, -25%)',
      }}
    >
      <Typography
        sx={{
          textAlign: 'center',
          color: color_text || '#040303ff',
          fontWeight: 'bold',
          fontSize: 11,
          textTransform: 'uppercase',
          ml: 2,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default PlateRibbon;
